/**
 * Angular imports.
 */
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
/**
 * Constant import.
 */
import { NUMBERS } from '../../constants/app.constants';
/**
 * Service imports.
 */
import { NewLanguageService } from './../../dataservices/new-language/new-language.service';

/**
 * Check box selection card popup.
 */
@Component({
  selector: 'app-check-box-select-card',
  templateUrl: './check-box-select-card.component.html',
  styleUrls: ['./check-box-select-card.component.scss']
})
export class CheckBoxSelectCardComponent implements OnChanges {

  /**
   * Check if modal is open/close.
   * Popup label.
   * total selected item length.
   * Max number can be selected.
   * Selection complete button disabled or not.
   * Selection complete label.
   * Show Mobile Back Button Flag for Members
   */
  @Input() isCheckBoxModalOpen = true;
  @Input() popupLabel = '';
  @Input() selectedListLength = 0;
  @Input() selectedLimit = 10;
  @Input() isButtonDisable = false;
  @Input() completeSelectionLabel = '';
  @Input() showMobileBackButton = false;
  /**
   * Member count of community.
   */
  @Input() memberCount: number;
  /**
   * Check if speciality popup is open.
   */
  @Input() isSpecialitySelectionOpen: boolean;

  /**
   * Mobile Back Button Flag for Members Popup
   */
  public mobileBackButtonFlag = false;

  /**
   * Emit the selected event outside.
   * Emit the close popup event outside.
   * Emiitting the count.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Output() emitSelected: EventEmitter<any> = new EventEmitter();
  @Output() emitCloseClicked: EventEmitter<void> = new EventEmitter();
  @Output() emitOriginalBack: EventEmitter<boolean> = new EventEmitter();
  @Output() memberSelected: EventEmitter<number> = new EventEmitter();

  constructor(public mls: NewLanguageService) {

  }

  /**
   * Set the selected button disable/Enable.
   */
  setIsButtonDisable(condition): void {
    if (condition) {
      this.isButtonDisable = true;
    } else {
      this.isButtonDisable = false;
    }
  }

  /**
   * Emit when popup is hide.
   */
  onCheckBoxModalHidden(): void {
    this.isCheckBoxModalOpen = false;
    this.emitCloseClicked.emit();
  }

  /**
   * Emit when selection is complete.
   */
  selectionComplete(): void {
    this.emitSelected.emit(this.memberCount);
    this.memberSelected.emit(this.memberCount);
  }

  /**
   * On Changes
   */
  ngOnChanges(): void {
    if (!this.memberCount) {
      this.memberCount = NUMBERS.ZERO;
    }
    this.mobileBackButtonFlag = this.showMobileBackButton;
    // this.memberCount = this.memberCount;

  }

  /**
   * Show Original Members List from Existing or Selected
   */
  showOriginalList(): void {
    this.mobileBackButtonFlag = false;
    this.emitOriginalBack.emit(false);
  }

}
